<template>
  <svg class="star-glow" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fill="#FFFFFF"
      d="m7.917 4.25l1.178 2.988l2.988 1.179l-2.988 1.178l-1.178 2.988l-1.179-2.988L3.75 8.417l2.988-1.179z" />
    <path
      fill="#FFFFFF"
      d="M7.917 3.833c.17 0 .325.105.387.264l1.112 2.82l2.82 1.112a.417.417 0 0 1 0 .775l-2.82 1.112l-1.112 2.82a.417.417 0 0 1-.775 0l-1.112-2.82l-2.82-1.112a.417.417 0 0 1 0-.775l2.82-1.112l1.112-2.82a.42.42 0 0 1 .388-.264m0 1.553L7.126 7.39a.42.42 0 0 1-.235.235l-2.005.79l2.005.792a.42.42 0 0 1 .235.234l.79 2.006l.792-2.006a.42.42 0 0 1 .234-.234l2.006-.791l-2.006-.791a.42.42 0 0 1-.234-.235zM4.167 3l.53 1.136l1.136.53l-1.136.531l-.53 1.136l-.53-1.136l-1.137-.53l1.136-.53z" />
  </svg>
</template>

<script setup lang="ts">
// Explicit empty setup script to reset compiler state
</script>
